import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import VerticalDividers from './VerticalDividers';
import ClientProvider from './client';
export default createDemo(import.meta.url, VerticalDividers, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/dividers/demos/vertical/VerticalDividers.tsx",
    "fileName": "VerticalDividers.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';\nimport FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';\nimport FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';\nimport FormatBoldIcon from '@mui/icons-material/FormatBold';\nimport Box from '@mui/material/Box';\nimport Divider, { dividerClasses } from '@mui/material/Divider';\n\nexport default function VerticalDividers() {\n  return (\n    <Box\n      sx={{\n        display: 'flex',\n        alignItems: 'center',\n        border: '1px solid',\n        borderColor: 'divider',\n        borderRadius: 1,\n        bgcolor: 'background.paper',\n        color: 'text.secondary',\n        '& svg': {\n          m: 1,\n        },\n        [`& .${dividerClasses.root}`]: {\n          mx: 0.5,\n        },\n      }}\n    >\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <FormatAlignLeftIcon />\n      <FormatAlignCenterIcon />\n      <FormatAlignRightIcon />\n      <Divider orientation=\"vertical\" flexItem />\n      <FormatBoldIcon />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 34,
        "focusedLines": 5,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';\nimport FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';\nimport FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';\nimport FormatBoldIcon from '@mui/icons-material/FormatBold';\nimport Box from '@mui/material/Box';\nimport Divider, { dividerClasses } from '@mui/material/Divider';\n\nexport default function VerticalDividers() {\n  return (\n    <Box\n      sx={{\n        display: 'flex',\n        alignItems: 'center',\n        border: '1px solid',\n        borderColor: 'divider',\n        borderRadius: 1,\n        bgcolor: 'background.paper',\n        color: 'text.secondary',\n        '& svg': {\n          m: 1,\n        },\n        [`& .${dividerClasses.root}`]: {\n          mx: 0.5,\n        },\n      }}\n    >\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <FormatAlignLeftIcon />\n      <FormatAlignCenterIcon />\n      <FormatAlignRightIcon />\n      <Divider orientation=\"vertical\" flexItem />\n      <FormatBoldIcon />\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "FormatAlignLeftIcon"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "FormatAlignCenterIcon"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 29
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "FormatAlignRightIcon"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 30
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Divider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "orientation"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "vertical",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "flexItem"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 31
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "FormatBoldIcon"
              ],
              " />"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 34,
    "focusedLines": 5,
    "collapsible": true,
    "externals": [
      "@mui/icons-material/FormatAlignLeft",
      "@mui/icons-material/FormatAlignCenter",
      "@mui/icons-material/FormatAlignRight",
      "@mui/icons-material/FormatBold",
      "@mui/material/Box",
      "@mui/material/Divider"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
